module.exports = __webpack_public_path__ + "static/sport/footer-banner2.9be453b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/footer-banner2.png
// module id = Wkre
// module chunks = 0